import type { SourceAudio } from '@/app/types';
import {
  getNextReadingText,
  getReadingTextsForLang,
  getVoiceCloneReadingTextLang,
  pickRandomReadingText,
  type VoiceCloneReadingTextLang,
} from '@/app/utils';

export type { VoiceCloneReadingTextLang };
export { getNextReadingText, getReadingTextsForLang, getVoiceCloneReadingTextLang, pickRandomReadingText };

export function formatAudioDuration(seconds: number): string {
  const normalizedSeconds = Math.max(0, Math.floor(seconds));
  const minutes = Math.floor(normalizedSeconds / 60);
  const remainingSeconds = normalizedSeconds % 60;

  return minutes > 0 ? `${minutes}m ${remainingSeconds}s` : `${remainingSeconds}s`;
}

export function formatRecordingTime(seconds: number): string {
  const normalizedSeconds = Math.max(0, Math.floor(seconds));
  const minutes = Math.floor(normalizedSeconds / 60);
  const remainingSeconds = normalizedSeconds % 60;

  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}

export function formatRecordingName(date: Date): string {
  const y = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const mi = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  return `${y}-${mo}-${d} ${h}:${mi}:${s}`;
}

export function getAudioFileName(audio: SourceAudio): string {
  const name = audio.name || 'voice-recording';
  return name.replace(/\.[^.]+$/, '');
}
